/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getPaymentTerms } from '../fn/payment-terms/get-payment-terms';
import { GetPaymentTerms$Params } from '../fn/payment-terms/get-payment-terms';
import { PaymentTermResponse } from '../models/payment-term-response';

@Injectable({ providedIn: 'root' })
export class PaymentTermsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPaymentTerms()` */
  static readonly GetPaymentTermsPath = '/payment-terms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPaymentTerms()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaymentTerms$Response(params?: GetPaymentTerms$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PaymentTermResponse>>> {
    return getPaymentTerms(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPaymentTerms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaymentTerms(params?: GetPaymentTerms$Params, context?: HttpContext): Observable<Array<PaymentTermResponse>> {
    return this.getPaymentTerms$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PaymentTermResponse>>): Array<PaymentTermResponse> => r.body)
    );
  }

}
